"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _constants = require("../constants");
const styleOverrides = {
  root: {
    justifyContent: 'center',
    minHeight: 'unset',
    position: 'relative',
    '&:after': {
      position: 'absolute',
      bottom: 0,
      content: '""',
      width: '100%',
      height: 3,
      backgroundColor: _constants.colors.oriGrey[200]
    }
  },
  indicator: {
    height: 3,
    zIndex: 1,
    backgroundColor: _constants.colors.text.primary
  },
  scroller: {
    flexGrow: 0,
    zIndex: 1
  }
};
const defaultProps = {
  textColor: 'primary'
};
var _default = exports.default = {
  styleOverrides,
  defaultProps
};
